// extracted by mini-css-extract-plugin
export default {"button":"Button_button__YvPvT","button--solid":"Button_button--solid__noYXg","button--outlined":"Button_button--outlined__8M6pf"};